import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetOrderByIdQuery } from "../../api/api";
import { useDecodedTokenResult } from "../../lib/utils";
import { pdf } from "@react-pdf/renderer";
import Invoice from "./OrderInvoice";
import Loader from "../LoaderComponent";
import { USER_ROLE } from "../../lib/constants";

const PrintPdf: React.FC = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const {
    data: orderData,
    isLoading,
    error,
  } = useGetOrderByIdQuery(
    { orderId: parseInt(orderId as string), role: USER_ROLE.CUSTOMER },
    { skip: !orderId }
  );

  const { role } = useDecodedTokenResult();
  const [isPrintReady, setIsPrintReady] = useState(false);

  useEffect(() => {
    if (!isLoading && !error && orderData && orderId) {
      setIsPrintReady(true);
    }
  }, [isLoading, error, orderData, orderId]);

  useEffect(() => {
    if (isPrintReady) {
      const {
        customerName,
        customerPhoneNumber,
        deliveryAddress,
        orderItems,
        serviceFee,
        paymentProcessingFee,
        customerNote,
        vendorNote,
        deliveryCharges,
        customerTotalAmount,
        oldTotalAmountCustomer,
        oldDeliveryChargesCustomer,
        deliveryNumber,
      } = orderData?.data;

      const generateAndPrintPDF = async () => {
        const pdfBlob = await pdf(
          <Invoice
            id={orderId}
            customerName={customerName}
            customerPhoneNumber={deliveryNumber}
            deliveryAddress={deliveryAddress}
            orderItems={orderItems}
            serviceFee={serviceFee}
            paymentProcessingFee={paymentProcessingFee}
            totalAmount={customerTotalAmount}
            customerNote={customerNote}
            vendorNote={vendorNote}
            userRole={role}
            deliveryFee={deliveryCharges}
            oldDeliveryFee={oldDeliveryChargesCustomer}
            oldTotalAmount={oldTotalAmountCustomer}
            isShowTransactionFee={false}
          />
        ).toBlob();
        const pdfURL = URL.createObjectURL(pdfBlob);

        // Open the PDF in the same window
        const printWindow = window.open(pdfURL, "_self");
      };

      generateAndPrintPDF();

      setIsPrintReady(false);
    }
  }, [isPrintReady, orderData, role, orderId, isLoading, error]);

  if (isLoading)
    return (
      <div>
        <Loader loading={"Loading..."} />
      </div>
    );
  if (error) return <div>Error loading order data.</div>;

  return (
    <div>
      <Loader loading={"Processing the print..."} />
    </div>
  );
};

export default PrintPdf;
